<template>
  <div>
    <!-- 操作记录 -->
    <div class="trade-order-block">
      <el-table :data="processRecordList" class="order-data-table ie-table">
        <el-table-column label="操作人">
          <template slot-scope="scope">
            <div v-if="scope.row.employeeLevelName && scope.row.processClientName !== '系统'">
              {{ scope.row.employeeLevelName }} - {{ scope.row.processClientName }}
            </div>
            <div v-else>{{ scope.row.processClientName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="processActionName" />
        <el-table-column label="目标状态">
          <template slot-scope="scope">
            {{ scope.row.targetApplyStatus !== '0'
              ? scope.row.targetDetailStatusName
              : scope.row.applyStatusName }}
          </template>
        </el-table-column>
        <el-table-column label="备注" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getRemark(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ scope.row.processTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-process-info',
  props: {
    processRecordList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    getRemark (item) {
      const remarkList = [item.processReasonValue, item.processRemark].filter(item => {
        return item
      })
      return remarkList.join('；')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
